/* eslint-disable no-param-reassign */
/*
 * @Description: Description
 * @Author: Dai Guo
 * @Date: 2022-05-10 11:12:19
 * @LastEditors: Kun Yang
 * @LastEditTime: 2022-05-16 15:13:07
 */
import LengthP2X from '../lengthTypes/lengthP2X';
import LengthP2XTop from '../lengthTypes/lengthP2XTop';
import LengthZ from '../lengthTypes/lengthZ';
import LengthZTop from '../lengthTypes/lengthZTop';
import MeshManage from '../meshManage';
import HightFrame from '../specialHandler/highFrame';
import { BASICTYPE_ENUM, LengthLocation, LengthType } from '../utils/enum';
import { FRAMEDEPTH, SKIRTINGBOARDCONFIG, TOPFRAME_GROUND } from '../utils/kitchenConfig';
import { checkFrameIsHighFrame, checkPreFrameIsHighFrame } from '../utils/renderUtils';
/**
 * 当L顶柜在l2、l3上面的时候
 * @param renderLThis renderIType类型的this,由于引入该类型的时候会导致循环引用所以修改为any类型
 */
const renderLP2XTop = (renderLThis) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    renderLThis.topLength1 = new LengthZ(renderLThis.templateJson, renderLThis.scene, LengthLocation.Top, LengthType.Length2, renderLThis.copyTemplateJson);
    renderLThis.topLength2 = new LengthP2X(renderLThis.templateJson, renderLThis.scene, LengthLocation.Top, LengthType.Length3, renderLThis.copyTemplateJson);
    const sealPlateData = renderLThis.getLengthSealPlate(BASICTYPE_ENUM.top);
    const topToGround = TOPFRAME_GROUND(renderLThis.templateJson);
    let datumPoint = null;
    let sealPlateMesh = null;
    const sealPlateLengthP2XPos = LengthP2XTop.getSealPlatePos(renderLThis.templateJson, BASICTYPE_ENUM.top);
    const sealPlateLengthZPos = LengthZTop.getSealPlatePos(renderLThis.templateJson, BASICTYPE_ENUM.top);
    // 移动柜子到指定位置
    (_c = (_b = (_a = renderLThis === null || renderLThis === void 0 ? void 0 : renderLThis.templateJson) === null || _a === void 0 ? void 0 : _a.top) === null || _b === void 0 ? void 0 : _b.length2) === null || _c === void 0 ? void 0 : _c.frames.forEach((element, index) => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
        // if (checkFrameIsHighFrame(element)) {
        //   return;
        // }
        if (checkPreFrameIsHighFrame((_c = (_b = (_a = renderLThis === null || renderLThis === void 0 ? void 0 : renderLThis.templateJson) === null || _a === void 0 ? void 0 : _a.top) === null || _b === void 0 ? void 0 : _b.length2) === null || _c === void 0 ? void 0 : _c.frames, index)) {
            const preEl = (_f = (_e = (_d = renderLThis === null || renderLThis === void 0 ? void 0 : renderLThis.templateJson) === null || _d === void 0 ? void 0 : _d.top) === null || _e === void 0 ? void 0 : _e.length2) === null || _f === void 0 ? void 0 : _f.frames[index - 1];
            const preMeshManage = new MeshManage(renderLThis.scene.getMeshByName(preEl.componentBasic.id));
            const meshManage = new MeshManage(renderLThis.scene.getMeshByName(element.componentBasic.id));
            const point = preMeshManage.getL2DatumPoint();
            point.y = topToGround - meshManage.getModelSize().y;
            const { rotation } = meshManage.moveL2ModelToPosition(point);
            renderLThis.rotationMeshes[element.componentBasic.id] = rotation;
            // 第一个柜子放在默认位置，第二个开始往外边排列，这个和后台align好的
        }
        else if (index > 0) {
            const preEl = (_j = (_h = (_g = renderLThis === null || renderLThis === void 0 ? void 0 : renderLThis.templateJson) === null || _g === void 0 ? void 0 : _g.top) === null || _h === void 0 ? void 0 : _h.length2) === null || _j === void 0 ? void 0 : _j.frames[index - 1];
            const preMeshManage = new MeshManage(renderLThis.scene.getMeshByName(preEl.componentBasic.id));
            const meshManage = new MeshManage(renderLThis.scene.getMeshByName(element.componentBasic.id));
            // 摆放补板后柜体处理
            if (sealPlateMesh && sealPlateLengthZPos && index === 1) {
                datumPoint = sealPlateMesh === null || sealPlateMesh === void 0 ? void 0 : sealPlateMesh.getL2DatumPoint();
            }
            else {
                datumPoint = preMeshManage.getL2DatumPoint();
            }
            datumPoint = preMeshManage.getL2DatumPoint();
            const { rotation } = meshManage.moveL2ModelToPosition(datumPoint);
            // 有补板数据，并且在第一个位置 第一个柜体移动补板z
            if (((_k = sealPlateData === null || sealPlateData === void 0 ? void 0 : sealPlateData.length2) === null || _k === void 0 ? void 0 : _k.length) && sealPlateLengthZPos === 1 && index === 1) {
                meshManage.mesh.position.z -= sealPlateMesh.getModelSize().z;
            }
            // 顶部高柜需要移动 x
            if (checkFrameIsHighFrame(element)) {
                if (index === sealPlateLengthZPos) {
                    meshManage.mesh.position.x -= -preMeshManage.getModelSize().x - sealPlateMesh.getModelSize().x;
                }
                meshManage.mesh.position.y = SKIRTINGBOARDCONFIG.HEIGHT;
            }
            renderLThis.rotationMeshes[element.componentBasic.id] = rotation;
        }
        else {
            // const preEl = renderLThis?.templateJson?.top?.length3?.frames[0];
            // const preMeshManage = new MeshManage(renderLThis.scene.getMeshByName(preEl.componentBasic.id));
            const meshManage = new MeshManage(renderLThis.scene.getMeshByName(element.componentBasic.id));
            const rotation = meshManage.addRotation(0, -Math.PI / 2, 0);
            const l2Length = ((_o = (_m = (_l = renderLThis === null || renderLThis === void 0 ? void 0 : renderLThis.templateJson) === null || _l === void 0 ? void 0 : _l.bottom) === null || _m === void 0 ? void 0 : _m.length2) === null || _o === void 0 ? void 0 : _o.length) / 100 || 0;
            renderLThis.rotationMeshes[element.componentBasic.id] = rotation;
            // const moveZ = sealPlateMesh ? sealPlateMesh.getModelSize().z : 0;
            meshManage.setModelPosition({
                x: -meshManage.getModelSize().z * 0.5 - 0.005,
                y: topToGround - meshManage.getModelSize().y,
                z: l2Length - meshManage.getModelSize().x * 0.5,
                // z: preMeshManage.getPosition().z - preMeshManage.getModelSize().z / 2
                //    - meshManage.getModelSize().x * 0.5 - moveZ,
            });
        }
        // 补板处理 otherLength情况
        if (sealPlateLengthZPos && index === sealPlateLengthZPos - 1) {
            const meshManage = new MeshManage(renderLThis.scene.getMeshByName(element.componentBasic.id));
            // 渲染补板
            sealPlateMesh = new LengthZTop(renderLThis.templateJson, renderLThis.scene, LengthLocation.Top, LengthType.Length2).renderSealPlate(sealPlateData.length2, meshManage, BASICTYPE_ENUM.top, element, renderLThis);
        }
    });
    datumPoint = null; // 还原默认值
    sealPlateMesh = null; // 还原默认值
    // 只要有补板数据就渲染，补板只会在第一个转角柜后面
    if (sealPlateLengthP2XPos === null) {
        const firstFrame = (_f = (_e = (_d = renderLThis === null || renderLThis === void 0 ? void 0 : renderLThis.templateJson) === null || _d === void 0 ? void 0 : _d.top) === null || _e === void 0 ? void 0 : _e.length2) === null || _f === void 0 ? void 0 : _f.frames[0];
        const meshManage = new MeshManage(renderLThis.scene.getMeshByName(firstFrame.componentBasic.id));
        // 渲染补板
        sealPlateMesh = new LengthP2XTop(renderLThis.templateJson, renderLThis.scene, LengthLocation.Top, LengthType.Length3).renderSealPlate(sealPlateData.length3, meshManage, BASICTYPE_ENUM.top, firstFrame, renderLThis);
    }
    (_j = (_h = (_g = renderLThis === null || renderLThis === void 0 ? void 0 : renderLThis.templateJson) === null || _g === void 0 ? void 0 : _g.top) === null || _h === void 0 ? void 0 : _h.length3) === null || _j === void 0 ? void 0 : _j.frames.forEach((element, index) => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v;
        if (HightFrame.checkEmptyPlaceholderHighFrame(element)) {
            return;
        }
        if (checkPreFrameIsHighFrame((_c = (_b = (_a = renderLThis === null || renderLThis === void 0 ? void 0 : renderLThis.templateJson) === null || _a === void 0 ? void 0 : _a.top) === null || _b === void 0 ? void 0 : _b.length3) === null || _c === void 0 ? void 0 : _c.frames, index)) {
            const preEl = (_f = (_e = (_d = renderLThis === null || renderLThis === void 0 ? void 0 : renderLThis.templateJson) === null || _d === void 0 ? void 0 : _d.top) === null || _e === void 0 ? void 0 : _e.length3) === null || _f === void 0 ? void 0 : _f.frames[index - 1];
            const preMeshManage = new MeshManage(renderLThis.scene.getMeshByName(preEl.componentBasic.id));
            const meshManage = new MeshManage(renderLThis.scene.getMeshByName(element.componentBasic.id));
            const point = preMeshManage.getDatumPoint({ x: -1, y: 0, z: 1 });
            point.y = topToGround - meshManage.getModelSize().y;
            const { rotation } = meshManage.moveModelToPosition(point, { x: -1, y: 0, z: 1 });
            renderLThis.rotationMeshes[element.componentBasic.id] = rotation;
        }
        else if (index > 0) {
            const preEl = (_j = (_h = (_g = renderLThis === null || renderLThis === void 0 ? void 0 : renderLThis.templateJson) === null || _g === void 0 ? void 0 : _g.top) === null || _h === void 0 ? void 0 : _h.length3) === null || _j === void 0 ? void 0 : _j.frames[index - 1];
            const preMeshManage = new MeshManage(renderLThis.scene.getMeshByName(preEl.componentBasic.id));
            const meshManage = new MeshManage(renderLThis.scene.getMeshByName(element.componentBasic.id));
            // 摆放补板后柜体处理
            if (sealPlateMesh && sealPlateLengthP2XPos && index === sealPlateLengthP2XPos) {
                datumPoint = sealPlateMesh.getDatumPoint({ x: -1, y: 0, z: 1 });
                datumPoint = Object.assign(Object.assign({}, datumPoint), { z: datumPoint.z + FRAMEDEPTH.TOP });
            }
            else {
                datumPoint = preMeshManage.getDatumPoint({ x: -1, y: 0, z: 1 });
            }
            const { rotation } = meshManage.moveModelToPosition(datumPoint, { x: -1, y: 0, z: 1 });
            // 顶部高柜需要移动 y
            if (checkFrameIsHighFrame(element)) {
                meshManage.mesh.position.y = SKIRTINGBOARDCONFIG.HEIGHT;
            }
            renderLThis.rotationMeshes[element.componentBasic.id] = rotation;
        }
        else {
            const preEl = (_m = (_l = (_k = renderLThis === null || renderLThis === void 0 ? void 0 : renderLThis.templateJson) === null || _k === void 0 ? void 0 : _k.top) === null || _l === void 0 ? void 0 : _l.length2) === null || _m === void 0 ? void 0 : _m.frames[0];
            const preMeshManage = new MeshManage(renderLThis.scene.getMeshByName(preEl.componentBasic.id));
            const meshManage = new MeshManage(renderLThis.scene.getMeshByName(element.componentBasic.id));
            const l2Length = ((_q = (_p = (_o = renderLThis === null || renderLThis === void 0 ? void 0 : renderLThis.templateJson) === null || _o === void 0 ? void 0 : _o.bottom) === null || _p === void 0 ? void 0 : _p.length2) === null || _q === void 0 ? void 0 : _q.length) / 100 || 0;
            // 补板位置为null 时，需要移动补板x
            const moveX = ((_r = sealPlateData === null || sealPlateData === void 0 ? void 0 : sealPlateData.length3) === null || _r === void 0 ? void 0 : _r.length) && !sealPlateLengthP2XPos ? (_s = sealPlateMesh === null || sealPlateMesh === void 0 ? void 0 : sealPlateMesh.getModelSize()) === null || _s === void 0 ? void 0 : _s.x : 0;
            meshManage.addRotation(0, -Math.PI, 0);
            meshManage.setModelPosition({
                x: -preMeshManage.getModelSize().z - meshManage.getModelSize().x * 0.5 - moveX,
                y: topToGround - meshManage.getModelSize().y,
                z: l2Length - meshManage.getModelSize().z * 0.5,
            });
        }
        // 补板处理 otherLength情况
        if (sealPlateLengthP2XPos && index === sealPlateLengthP2XPos - 1) {
            const isFirstPos = sealPlateLengthP2XPos === null;
            const firstFrame = isFirstPos ? (_v = (_u = (_t = renderLThis === null || renderLThis === void 0 ? void 0 : renderLThis.templateJson) === null || _t === void 0 ? void 0 : _t.top) === null || _u === void 0 ? void 0 : _u.length3) === null || _v === void 0 ? void 0 : _v.frames[0] : element;
            const meshManage = new MeshManage(renderLThis.scene.getMeshByName(firstFrame.componentBasic.id));
            // 渲染补板
            sealPlateMesh = new LengthP2XTop(renderLThis.templateJson, renderLThis.scene, LengthLocation.Top, LengthType.Length3).renderSealPlate(sealPlateData.length3, meshManage, BASICTYPE_ENUM.top, firstFrame, renderLThis);
        }
    });
};
export default renderLP2XTop;
